import Lottie from "lottie-react";
import * as animation from "./splash.json";
import { useRef, useEffect } from "react";

interface SplashScreenProps {
    play: boolean;
}

export default function LottieInitAnimation(props: SplashScreenProps) {
  const lottieRef = useRef<any>();

  const defaultOptions = {
    loop: true,
    autoplay: false,
    animationData: animation,
  };


  /*useEffect( () => {
    if (props.play && lottieRef.current) {
      lottieRef.current.play();
      console.log("Playing animation...");
    } else if (props.play==false && lottieRef.current) {
      lottieRef.current.stop();
      console.log("Stopping animation...");
      //lottieRef.current.destroy();
    }
  },[props.play]);*/

  return (
    <div
        className="splash-screen-container"
        style={{
           position: "absolute",
           top: 0,
           left: 0,
           width: "100%",
           height: "100%",
           backgroundColor: "#060B0C"
        }}
    >
      <Lottie lottieRef={lottieRef}  animationData={animation} autoPlay={true}  loop={true} style={{
        width:"100%",
        height:"100%",
        backgroundColor:"transparent",
        zIndex: 2000
      }} />
    </div>
  )
}